import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type {
  GetVirtualBankAccountsAccountNumberMovementsFilterEntryType,
  GetVirtualBankAccountsAccountNumberMovementsParams
} from 'api/customerApi';

import type { LocalState } from './localState';

type Params = LocalState & GlobalFiltersState & { shouldIgnoreCursor: boolean };

export const apiParams = function (
  state: Partial<Params>
): GetVirtualBankAccountsAccountNumberMovementsParams {
  const filter: {
    entry_type?: GetVirtualBankAccountsAccountNumberMovementsFilterEntryType;
  } = {};

  // Apply filters if they exist and are not 'All'
  if (state.filters?.entry_type && state.filters?.entry_type !== 'All') {
    filter.entry_type = state.filters.entry_type;
  }

  const params: GetVirtualBankAccountsAccountNumberMovementsParams = {
    'filter[entry_type]': filter.entry_type,
    ...(state.dateRange?.from && { created_after: state.dateRange.from }),
    ...(state.dateRange?.to && { created_before: state.dateRange.to }),
    ...(state.cursorBefore && { cursor_before: state.cursorBefore }),
    ...(state.cursorAfter && { cursor_after: state.cursorAfter })
  };

  return params;
};
